// extracted by mini-css-extract-plugin
export default {"component":"TableFooter_component__-xpYM"};